import React, { useEffect, useState } from "react"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

import { Link } from "react-router-dom"
import { AvForm, AvField } from "availity-reactstrap-validation"

import { db } from "../../helpers/firebase_helper"

import { useHistory } from "react-router-dom"

import API from "../../api/api"

import SweetAlert from "react-bootstrap-sweetalert"
/**
 * This section handles add service and edit service.
 */

const TableListServices = ({
  createButton,
  title,
  titleList,
  tableData,
  edit,
  navLocation,
  getServiceList,
}) => {
  const history = useHistory()
  let rowNumber = 1
  const [modal_standard, setmodal_standard] = useState(false)
  const [modal_large, setmodal_large] = useState(false)
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [modal_small, setmodal_small] = useState(false)
  const [modal_center, setmodal_center] = useState(false)
  const [modal_scroll, setmodal_scroll] = useState(false)
  const [modal_fullscreen, setmodal_fullscreen] = useState(false)
  const [modal_backdrop, setmodal_backdrop] = useState(false)
  const [servicesList, setServicesList] = useState([])
  const [editEnable, setEditEnable] = useState(false)
  const [serviceData, setServiceData] = useState({
    name: "",
    disabled: false,
  })

  function tog_standard() {
    setmodal_standard(!modal_standard)
    removeBodyCss()
  }

  const getServiceDetails = async id => {
    try {
      await API.getSingleService(id)
        .then(response => {
          console.log("called response", id)
          // setServicesList(response.data.data)
          console.log("services response", response.data.data)
          const result = response.data.data
          setServiceData({
            id: id,
            partner_type: result.partner_type,
            job: result.job.code,
            base_fare: result.base_fare,
            additional_fare: result.additional_fare,
            helper_fare: result.helper_fare,
            helper_additional_fare: result.helper_additional_fare,
            known_issues: result.known_issues,
          })
        })
        .catch(e => {
          console.log("called inside error", id)
        })
    } catch (e) {
      console.log("called outside error", id)
    }
  }

  const tog_fullscreen = async props => {
    console.log(props)
    if (props) {
      if (props[0] === "edit") {
        console.log("equalq")
        await getServiceDetails(props[1])
        setmodal_fullscreen(!modal_fullscreen)
      } else if (props[0] === "create") {
        setServiceData({
          id: null,
          partner_type: "",
          job: 0,
          base_fare: 0,
          additional_fare: 0,
          helper_fare: 0,
          helper_additional_fare: 0,
          known_issues: 0,
        })
        setmodal_fullscreen(!modal_fullscreen)
      }
    } else {
      setmodal_fullscreen(!modal_fullscreen)
    }
    removeBodyCss()
  }

  function tog_backdrop() {
    setmodal_backdrop(!modal_backdrop)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function tog_large() {
    setmodal_large(!modal_large)
    removeBodyCss()
  }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  function tog_small() {
    setmodal_small(!modal_small)
    removeBodyCss()
  }

  function tog_center() {
    setmodal_center(!modal_center)
    removeBodyCss()
  }

  function tog_scroll() {
    setmodal_scroll(!modal_scroll)
    removeBodyCss()
  }

  const [fnm, setfnm] = useState(false)
  const [lnm, setlnm] = useState(false)
  const [unm, setunm] = useState(false)
  const [city, setcity] = useState(false)
  const [stateV, setstateV] = useState(false)

  function handleSubmit(e) {
    e.preventDefault()

    var fnm = document.getElementById("validationTooltip01").value
    var lnm = document.getElementById("validationTooltip02").value
    var unm = document.getElementById("validationTooltipUsername").value
    var city = document.getElementById("validationTooltip03").value
    var stateV = document.getElementById("validationTooltip04").value

    if (fnm === "") {
      setfnm(false)
    } else {
      setfnm(true)
    }

    if (lnm === "") {
      setlnm(false)
    } else {
      setlnm(true)
    }

    if (unm === "") {
      setunm(false)
    } else {
      setunm(true)
    }

    if (city === "") {
      setcity(false)
    } else {
      setcity(true)
    }

    if (stateV === "") {
      setstateV(false)
    } else {
      setstateV(true)
    }

    var d1 = document.getElementsByName("validate")

    document.getElementById("tooltipForm").classList.add("was-validated")

    for (var i = 0; i < d1.length; i++) {
      d1[i].style.display = "block"
    }
  }

  //for change tooltip display propery
  function changeHandeler(event, eleId) {
    if (event.target.value !== "")
      document.getElementById(eleId).style.display = "none"
    else document.getElementById(eleId).style.display = "block"
  }

  const postService = () => {
    // if (editEnable) {
    //   try {
    //     API.updateService(serviceData)
    //       .then(response => {
    //         getServiceList()
    //       })
    //       .catch(e => {})
    //   } catch (e) {}
    // } else {
    //   try {
    //     API.saveServices(serviceData)
    //       .then(response => {
    //         getServiceList()
    //       })
    //       .catch(e => {})
    //   } catch (e) {}
    // }
    try {
      API.serachUser(9281).then(res => console.log(res))
    } catch (e) {
      console.log(e)
    }

    console.log(serviceData)
    setEditEnable(false)
  }

  const getServices = async () => {
    try {
      API.getServicesList()
        .then(response => {
          setServicesList(response.data.data)
          console.log("services response", response.data.data)
        })
        .catch(e => {})
    } catch (e) {}
  }

  useEffect(() => {
    console.log("Services api called")
    getServices()
  }, [])

  useEffect(() => {
    console.log("Table data", tableData, title)
  }, [tableData, serviceData, servicesList])

  /**
   * ********************************************************************
   *
   * FIREBASE INTEGRATION
   *
   * **********************************************************************
   */

  const [showDeleteService, setDeleteService] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [selectedServiceId, setSelectedServiceId] = useState("")
  const [serviceDetailsData, setServiceDetailsData] = useState({
    name: "",
    disabled: true,
  })
  const [openServiceModal, setOpenServiceModal] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [openServiceCreateModal, setOpenServiceCreateModal] = useState(false)
  const [editServiceModal, setEditServiceModal] = useState(false)
  const [selectingServiceStatus, setSelectingServiceStatus] = useState("")

  const addService = async () => {
    await db.collection("services").add(serviceDetailsData)
    setShowSuccessModal(true)
    setEditServiceModal(false)
    setOpenServiceModal(false)
    getServiceList()
  }

  const [serviceEditedData, setServiceEditedData] = useState({
    name: "",
    disabled: true,
  })

  /**
   * This function deletes service
   */
  const deleteService = async () => {
    await db.collection("services").doc(selectedServiceId).delete()
    getServiceList()
    setShowSuccessModal(true)
  }

  /**
   * This function fills up the modal popup for the selected service edit
   * @param {object} data
   */
  const keepEditValueInServiceEdit = data => {
    setServiceEditedData({
      name: data.name,
      disabled: data.disabled,
    })
  }

  const saveEditedServiceData = async () => {
    await db
      .collection("services")
      .doc(selectedServiceId)
      .set(serviceEditedData, {
        merge: true,
      })
    setServiceEditedData({
      name: "",
      disabled: true,
    })
    setOpenServiceModal(false)
    setEditServiceModal(false)
    setShowSuccessModal(true)
    getServiceList()
  }
  

  return (
    <Row>
      <Col md={12}>
        <Card>
          <CardBody>
            <Row className="mt-2">
              <Col md="10">
                <h4>{title}</h4>
              </Col>
              <Col md="2">
                {createButton && (
                  <Button
                    onClick={() => {
                      setOpenServiceModal(true)
                      setServiceDetailsData({
                        name: "",
                        disabled: true,
                      })
                      setServiceEditedData({
                        name: "",
                        disabled: true,
                      })
                      // tog_fullscreen(["create"])
                    }}
                  >
                    Create new Service
                  </Button>
                )}
              </Col>
            </Row>

            {/* <Link to="/details"> */}
            <div className="table-responsive">
              <Table className="table mb-0">
                <thead>
                  <tr>
                    {titleList &&
                      titleList?.map((item, index) => {
                        return <th key={`title-${index}`}>{item}</th>
                      })}
                  </tr>
                </thead>
                <tbody>
                  {tableData.length > 0 &&
                    tableData?.map(item => {
                      return (
                        <>
                          {console.log("item id____________________", item.id)}
                          <tr id={item?.id} key={`order-${item?.id}`}>
                            <th
                              scope="row"
                              onClick={() => {
                                if (navLocation)
                                  history.push(`${navLocation}${item?.id}`)
                              }}
                            >
                              {rowNumber++}
                            </th>
                            <td
                              onClick={() => {
                                if (navLocation)
                                  history.push(`${navLocation}${item?.id}`)
                              }}
                            >
                              {item?.name}
                            </td>
                            <td
                              onClick={() => {
                                if (navLocation)
                                  history.push(`${navLocation}${item?.id}`)
                              }}
                            >
                              {item?.disabled ? "Disabled" : "Enabled"}
                            </td>
                            {/* <td>{item?.additional_fare}</td>
                            <td>{item?.job?.name}</td> */}
                            <td>
                              {" "}
                              {edit && (
                                <Button
                                  id={item?.id}
                                  onClick={e => {
                                    // const props = ["edit", item.id]
                                    // tog_fullscreen(props)
                                    keepEditValueInServiceEdit(item)
                                    setOpenServiceModal(true)
                                    setEditServiceModal(true)
                                    setSelectedServiceId(item.id)
                                    // setEditEnable(true)
                                  }}
                                >
                                  Edit
                                </Button>
                              )}
                              {edit && (
                                <Button
                                  id={item?.id}
                                  style={{ marginLeft: "10px" }}
                                  onClick={e => {
                                    setSelectedServiceId(item.id)
                                    setDeleteService(true)
                                  }}
                                >
                                  Delete
                                </Button>
                              )}
                            </td>
                          </tr>
                        </>
                      )
                    })}
                </tbody>
              </Table>
              <Col sm={6} md={4} xl={3}>
                <Modal
                  size="sm"
                  isOpen={modal_fullscreen}
                  toggle={() => {
                    tog_fullscreen()
                  }}
                  className="modal-fullscreen"
                >
                  <Row>
                    <Col xl="20">
                      <Card>
                        <CardBody>
                          <h3 className="card-title mb-4">
                            Service Add / Edit
                          </h3>

                          <AvForm className="needs-validation">
                            {/* <Row>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom01">
                                    Partner Type
                                  </Label>
                                  <AvField
                                    name="partnerType"
                                    placeholder="Partner Type"
                                    type="text"
                                    errorMessage=" Please provide a valid partner type."
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="validationCustom01"
                                    value={`${serviceData.partner_type}`}
                                    onChange={e => {
                                      setServiceData({
                                        ...serviceData,
                                        partner_type: e.target.value,
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom02">
                                    Base Fare
                                  </Label>
                                  <AvField
                                    name="baseFare"
                                    placeholder="Base Fare"
                                    type="text"
                                    value={serviceData.base_fare}
                                    errorMessage="Please provide a valid base fare."
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="validationCustom02"
                                    onChange={e => {
                                      setServiceData({
                                        ...serviceData,
                                        base_fare: parseInt(e.target.value),
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom03">
                                    Additional Fare
                                  </Label>
                                  <AvField
                                    name="additionalFare"
                                    placeholder="Additional Fare"
                                    type="text"
                                    errorMessage=" Please provide a valid additional fare."
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="validationCustom03"
                                    value={serviceData.additional_fare}
                                    onChange={e => {
                                      setServiceData({
                                        ...serviceData,
                                        additional_fare: parseInt(
                                          e.target.value
                                        ),
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row> */}
                            <Row>
                              {/* <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom04"   type="text">
                                    Name
                                  </Label>
                                  <AvField
                                    name="jobType"
                                    placeholder="Job Type"
                                    type="text"
                                    value={serviceData.job}
                                    errorMessage=" Please provide a valid job type."
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="validationCustom04"
                                    onChange={e => {
                                      setServiceData({
                                        ...serviceData,
                                        job: parseInt(e.target.value),
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col> */}
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom05">
                                    Name
                                  </Label>
                                  <AvField
                                    name="Name"
                                    placeholder="Service name"
                                    type="text"
                                    errorMessage="Please enter a valid name."
                                    className="form-control"
                                    value={serviceDetailsData.name}
                                    validate={{ required: { value: true } }}
                                    id="validationCustom05"
                                    onChange={e => {
                                      setServiceDetailsData({
                                        ...serviceDetailsData,
                                        name: e.target.value,
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              {/* <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom06">
                                    Helper Additional Fare
                                  </Label>
                                  <AvField
                                    name="zip"
                                    placeholder="Helper Additional Fare"
                                    type="text"
                                    errorMessage=" Please provide a valid helper additional fare."
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="validationCustom06"
                                    value={serviceData.helper_additional_fare}
                                    onChange={e => {
                                      setServiceData({
                                        ...serviceData,
                                        helper_additional_fare: parseInt(
                                          e.target.value
                                        ),
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col> */}
                              {/* <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom07">
                                    Known Issues (6 Items)
                                  </Label>
                                  <AvField
                                    name="knownIssues"
                                    placeholder="Known issues"
                                    type="text"
                                    errorMessage=" Please provide a valid known issues."
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="validationCustom07"
                                    value={serviceData.known_issues}
                                    onChange={e => {
                                      setServiceData({
                                        ...serviceData,
                                        known_issues: e.target.value,
                                      })
                                    }}
                                  />
                                </FormGroup>
                              </Col> */}
                            </Row>
                            {/* <Row>
                              <Col lg="12">
                                <FormGroup className="mb-3">
                                  <div className="form-check">
                                    <Input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="invalidCheck"
                                    />
                                    <Label
                                      className="form-check-label"
                                      htmlFor="invalidCheck"
                                    >
                                      {" "}
                                      Agree to terms and conditions
                                    </Label>
                                  </div>
                                </FormGroup>
                              </Col>
                            </Row> */}
                            {/* <Button color="primary" type="submit">
                              Submit
                            </Button> */}
                            <Row>
                              <Col md="10" />
                              <Col md="2">
                                <div>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      tog_fullscreen()
                                      setEditEnable(false)
                                    }}
                                    className="btn btn-secondary waves-effect"
                                    data-dismiss="modal"
                                    style={{}}
                                  >
                                    Close
                                  </button>
                                  <button
                                    type="submit"
                                    className="btn btn-primary waves-effect waves-light"
                                    style={{ marginLeft: "10px" }}
                                    onClick={() => {
                                      postService()
                                      tog_fullscreen()
                                      addService()
                                    }}
                                  >
                                    Save changes
                                  </button>
                                </div>
                              </Col>
                            </Row>
                          </AvForm>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Modal>
              </Col>
            </div>
            {/* </Link> */}
          </CardBody>
        </Card>
      </Col>
      <Modal
        isOpen={openServiceModal}
        backdrop={true}
        toggle={() => {
          setEditServiceModal(false)
          setOpenServiceModal(false)
        }}
      >
        <ModalHeader>Service</ModalHeader>
        <ModalBody>
          <div className="pb-3">
            Service Name:{" "}
            <Input
              value={serviceEditedData.name}
              onChange={e => {
                setServiceEditedData({
                  ...serviceEditedData,
                  name: e.target.value,
                })
                setServiceDetailsData({
                  ...serviceEditedData,
                  name: e.target.value,
                })
              }}
            />
          </div>
          <div className="pb-3">
            Status:{" "}
            <Dropdown
              isOpen={dropdownOpen}
              toggle={() => {
                if (editServiceModal) setDropdownOpen(!dropdownOpen)
              }}
            >
              <DropdownToggle className="btn btn-secondary" caret>
                {editServiceModal
                  ? serviceEditedData.disabled
                    ? "Disabled"
                    : "Enabled"
                  : "Disabled"}
                <i className="mdi mdi-chevron-down" />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={e => {
                    if (editServiceModal) {
                      setServiceEditedData({
                        ...serviceEditedData,
                        disabled: false,
                      })
                    }
                  }}
                >
                  Enable
                </DropdownItem>
                <DropdownItem
                  onClick={e => {
                    if (editServiceModal) {
                      setServiceEditedData({
                        ...serviceEditedData,
                        disabled: true,
                      })
                    }
                  }}
                >
                  Disable
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </ModalBody>
        <div className="m-auto mb-3">
          <Button
            variant="dark"
            className="bg-dark text-white m-auto"
            onClick={() => {
              setOpenServiceModal(false)
              setEditServiceModal(false)
            }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            className="bg-success text-white m-auto"
            onClick={() => {
              if (editServiceModal) {
                saveEditedServiceData()
              } else {
                addService()
              }
            }}
          >
            {editServiceModal ? "Update" : "Create"}
          </Button>
        </div>
      </Modal>
      <SweetAlert
        warning
        // show={showDeletePartnerAlert}
        showCancel
        show={showDeleteService}
        confirmBtnText="Confirm"
        confirmBtnBsStyle={"danger"}
        title={"Are you sure want to delete ?"}
        onConfirm={() => {
          deleteService()
          setDeleteService(false)
        }}
        onCancel={() => {
          setDeleteService(false)
        }}
        focusCancelBtn
      ></SweetAlert>
      <SweetAlert
        success
        show={showSuccessModal}
        confirmBtnText="Ok"
        confirmBtnBsStyle={"success"}
        title={"Success"}
        onConfirm={() => {
          setShowSuccessModal(false)
          setDeleteService(false)
        }}
      ></SweetAlert>
    </Row>
  )
}

export default TableListServices

//TODO: REPLACE THE  TABLE DATA STATIC VALUE WITH API
